import createNamespaceContext from './helper/createNamespaceContext';
export const EDITOR_CONTEXT = 'fabricEditorCtx';
export let EDITOR_APPEARANCE_CONTEXT = /*#__PURE__*/function (EDITOR_APPEARANCE_CONTEXT) {
  EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
  EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
  EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
  EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
  EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
  return EDITOR_APPEARANCE_CONTEXT;
}({});
export const FabricEditorAnalyticsContext = createNamespaceContext(EDITOR_CONTEXT, 'FabricEditorAnalyticsContext');